import { get } from "lodash";
import { Vehicle } from "../../../../types";
import styles from './styles.module.css';

type VehicleDetailsProps = {
  vehicle: Vehicle;
}

type SectionItem = {
  title: string;
  dataKey: string;
  render?: (value: string, record: Vehicle) => string;
}

type Section = {
  title: string;
  items: SectionItem[];
}

const sections: Section[] = [
  {
    title: 'Carrosserie et habitacle',
    items: [
      {
        title: 'Type de carrosserie',
        dataKey: 'details.carrosserie',
      },
      {
        title: 'Nombre de passagers',
        dataKey: 'details.nr_passagers',
      },
      {
        title: 'Nombre de portes',
        dataKey: 'details.nb_portes',
      },
    ]
  },
  {
    title: 'Moteur, transmission et consommation',
    items: [
      {
        title: 'Type de moteur',
        dataKey: 'details.type_moteur',
      },
      {
        title: 'Type de transmission',
        dataKey: 'details.type_transmission',
      },
      {
        title: 'Cylindrée',
        dataKey: 'details.ccm',
      },
      {
        title: 'Emissions de CO2',
        dataKey: 'details.co2',
        render: (value: string, record: Vehicle) => `${value} g/km`,
      }
    ]
  }
]

type SectionProps = {
  section: Section;
  vehicle: Vehicle;
}

type SectionItemProps = {
  item: SectionItem;
  value: string;
}

const SectionItem: React.FC<SectionItemProps> = (props) => {
  const {
    item,
    value
  } = props;

  return (
    <tr>
      <td className="font-medium w-[50%]">
        {item.title}
      </td>
      <td>
        {value}
      </td>
    </tr>
  )
}

const Section: React.FC<SectionProps> = (props) => {
  const {
    section,
    vehicle
  } = props;

  return (
    <div className={styles.section}>
      <h3 className="text-lg font-bold">{section.title}</h3>
      <div className="px-4">
        <table>
          <tbody>
            {section.items.map((item) => {
              const value = get(vehicle, item.dataKey);
              if(!value) return null;

              return (
                <SectionItem
                  key={item.title}
                  item={item}
                  value={item.render ? item.render(value, vehicle) : value}
                />
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  )
}

const VehicleDetails: React.FC<VehicleDetailsProps> = (props) => {
  const {
    vehicle
  } = props;

  return (
    <div className={styles.container}>
      {sections.map((section) => (
        <Section
          key={section.title}
          section={section}
          vehicle={vehicle}
        />
      ))}
    </div>
  )
}

export default VehicleDetails;